module.exports = __webpack_public_path__ + "static/img/360_mac_5.06f8108.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step/360_mac_5.png
// module id = wkyh
// module chunks = 94